import {Component, Input, OnInit} from '@angular/core';
import {NzUploadFile} from "ng-zorro-antd/upload";
import {NzNotificationService} from "ng-zorro-antd/notification";
import {DomSanitizer} from "@angular/platform-browser";
import {EMPTY, Observable, of} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {FileInfoModel, VssUiConfig} from '../../../vss-ui.model';

@Component({
  selector: 'vss-ui-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss']
})
export class UploadImageComponent implements OnInit {

  @Input() urlImage!: string
  @Input() maxSizeMB = 5
  uploading = false;
  file?: any;
  fileUrl?: any;
  uploadService$: ((files: File[], params?: any) => Observable<any>) = (files, params) => of();

  constructor(
    private notificationService: NzNotificationService,
    private domSanitizer: DomSanitizer,
    vssUiConfig: VssUiConfig
  ) {
    if(vssUiConfig.uploadService$) {
      this.uploadService$ = vssUiConfig.uploadService$
    }
  }

  ngOnInit(): void {
  }

  /***
   * return False -> manual upload bằng cách call hàm handleUpload()
   * return True -> tự động upload với hàm handleUpload()
   * @return boolean
   ***/
  beforeUpload = (file: NzUploadFile): boolean => {
    if (!(/(png|jpg|jpeg){1}/g).test(file.type || '')) {
      this.notificationService.error('', 'File không đúng định dạng');
      return false;
    }
    if (file.size! > (this.maxSizeMB * 1024 * 1024)) {
      this.notificationService.error('', `Dung lượng ảnh vượt quá ${this.maxSizeMB} MB`);
      return false;
    }
    this.file = file
    this.getBase64(file as any);
    return false;
  };

  handleUpload(): Observable<FileInfoModel> {
    return (this.file ? this.uploadService$([this.file]).pipe(
      catchError(err => of(null))
    ) : of(null)) as Observable<FileInfoModel>
  }

  getBase64(file: File){
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.fileUrl = reader.result;
    };
  }

}
